import DemoRepository from "../../../../.remote/gatsby-imgly-source/android-10.4.0/docs/packages/PESDK/docs/android/shared/demo-repository";
import ExampleApp from "../../../../.remote/gatsby-imgly-source/android-10.4.0/docs/packages/PESDK/docs/android/shared/example-app";
import * as React from 'react';
export default {
  DemoRepository,
  ExampleApp,
  React
};